/* eslint-disable @typescript-eslint/no-unused-expressions */

import { useState } from 'react';

import { random } from 'lodash';

import { FUNNY_MESSAGES } from './utils';

const getQuote = (): string =>
    FUNNY_MESSAGES[random(0, FUNNY_MESSAGES.length - 1)];

const useQuote = (): readonly [string, () => void] => {
    const [quote, setQuote] = useState<string>(getQuote());

    const refreshQuote = (): void => {
        const newQuote = getQuote();
        setQuote(newQuote);
    };

    return [quote, refreshQuote] as const;
};

export { useQuote };
